import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { EndCustomerService } from 'src/app/services/end-customer.service';

@Component({
  selector: 'app-equipments',
  templateUrl: './equipments.component.html',
  styleUrls: ['./equipments.component.scss']
})
export class EquipmentsComponent implements OnInit {

  @Input() equipmentForm!: FormGroup;
  @Input() endCustomerData: any;

  @Output() onUpdate: EventEmitter<any> = new EventEmitter();

  equipments: any[] = [];
  filteredEquipments: any[] = [];
  equipmentData: any[] = [];

  showEditForm: boolean = false;
  copyEquipmentSetForm: any;

  noRecordsFoundData: boolean = false;
  isEquipmentInputFieldClicked: boolean = false;

  constructor(private endCustomerService: EndCustomerService) { }

  ngOnInit(): void {
    this.getEquipments();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const targetElement = event.target as HTMLElement;
    const dropdownElement = document.querySelector('.skillSetDopdownContainer');
    const formFieldElement = document.querySelector('.equipment');

    if (dropdownElement?.contains(targetElement) || formFieldElement?.contains(targetElement)) {
      return;
    }
    this.isEquipmentInputFieldClicked = false;
  }

  getEquipments(callback?: () => void) {
    this.endCustomerService.executeGetRequestURL(MweConstants.allEquipmentsUrl, null).subscribe(data => {
        if (data?.data?.length > 0) {
            this.equipments = data.data;
            this.filteredEquipments = [...this.equipments];

            if (callback) {
                callback();
            }

            if (this.equipmentForm.get('equipments')?.value?.length > 0) {
                this.patchSelectedEquipments();
            }
        }
    });
 }


  filterEquipments(event: any) {
    this.isEquipmentInputFieldClicked = true;
    const searchText = event.target.value.toLowerCase();
    this.filteredEquipments = this.equipments.filter((equipment: any) =>
      equipment.name.toLowerCase().includes(searchText)
    );
    this.noRecordsFoundData = this.filteredEquipments.length === 0;
  }

  checkBoxClicked(equipment: any) {
    const equipmentsControl = this.equipmentForm.get('equipments')?.value || [];
    if (equipmentsControl.includes(equipment.id)) {
      const updatedEquipments = equipmentsControl.filter((id: any) => id !== equipment.id);
      this.equipmentForm.get('equipments')?.patchValue(updatedEquipments);
    } else {
      equipmentsControl.push(equipment.id);
      this.equipmentForm.get('equipments')?.patchValue(equipmentsControl);
    }
  }
  keyDownButton(equipment: any, event: any) {
    if (event.key === 'Enter') {
      let equipmentsControl = this.equipmentForm.get('equipments')?.value;
      if (equipmentsControl && equipmentsControl.includes(equipment.id)) {
        equipmentsControl = equipmentsControl.filter((id: any) => id !== equipment.id);
        this.equipmentForm.get('equipments')?.patchValue(equipmentsControl);
      } else if (equipmentsControl && !equipmentsControl.includes(equipment.id)) {
        equipmentsControl.push(equipment.id);
        this.equipmentForm.get('equipments')?.patchValue(equipmentsControl);
      }
    }
  }

  equipmentInputFieldClicked() {
    this.isEquipmentInputFieldClicked = true;
  }

  update() {
    this.onUpdate.emit(30);
    this.refresh();
  }

  cancel() {
    this.showEditForm = false;
    this.equipmentForm.reset(this.copyEquipmentSetForm);
    this.getEquipmentData();
}


  editEquipments() {
    this.copyEquipmentSetForm = JSON.parse(JSON.stringify(this.equipmentForm.value));
    this.showEditForm = true;

    this.getEquipments(() => {
        this.patchSelectedEquipments();
    });
}


patchSelectedEquipments() {
    const selectedEquipments = this.equipmentForm.get('equipments')?.value || [];

    this.filteredEquipments = this.equipments.map(equipment => ({
        ...equipment,
        selected: selectedEquipments.includes(equipment.id)
    }));

    this.getEquipmentData();
}

refresh() {
  this.showEditForm = false;
  this.getEquipments(() => {
      this.patchSelectedEquipments();
  });
}


  getEquipmentData() {
    const selectedIds = this.equipmentForm.get('equipments')?.value || [];

    this.equipmentData = this.equipments.filter((obj1: any) =>
        selectedIds.includes(obj1.id)
    );

    this.filteredEquipments = this.equipments.map((equipment: any) => ({
        ...equipment,
        selected: selectedIds.includes(equipment.id)
    }));
}


  remove(i: number): void {
    this.equipmentForm.get('equipments')?.value.splice(i, 1);
    this.equipmentForm.get('equipments')?.patchValue(this.equipmentForm.get('equipments')?.value);
  }

  getEquipmentName(id: any) {
    return this.equipments.find((obj: any) => obj?.id === id)?.name;
  }
}
